/* IntegroPet – nuovo menu: apertura mega menu (desktop) e schede/fisarmonica (mobile) */
(function () {
  'use strict';

  /* ---------- Desktop: mega menu ---------- */
  var lastPointer = 'mouse';
  document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);

  function closeAll(except) {
    document.querySelectorAll('[data-ip-mega].is-open').forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var t = item.querySelector('.ip-top');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  function activateGroup(item, rail) {
    var target = rail.getAttribute('data-ip-group');
    item.querySelectorAll('[data-ip-group]').forEach(function (r) {
      var on = r === rail;
      r.classList.toggle('is-active', on);
    });
    item.querySelectorAll('.ip-group[id]').forEach(function (g) {
      g.hidden = g.id !== target;
    });
  }

  document.querySelectorAll('[data-ip-mega]').forEach(function (item) {
    var trigger = item.querySelector('.ip-top');
    var openTimer, closeTimer;
    if (!trigger) return;

    function open() {
      clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      clearTimeout(openTimer);
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    item.addEventListener('mouseenter', function () {
      if (lastPointer === 'touch') return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(open, 80);
    });
    item.addEventListener('mouseleave', function () {
      if (lastPointer === 'touch') return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, 180);
    });

    /* primo tocco (o Invio da tastiera) apre il pannello, il secondo segue il link */
    trigger.addEventListener('click', function (e) {
      if (!item.classList.contains('is-open')) {
        e.preventDefault();
        open();
      }
    });

    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) {
        close();
        trigger.focus();
      }
    });
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !item.contains(e.relatedTarget)) close();
    });

    item.querySelectorAll('[data-ip-group]').forEach(function (rail) {
      var wasActive = false;
      rail.addEventListener('pointerdown', function () { wasActive = rail.classList.contains('is-active'); });
      rail.addEventListener('mouseenter', function () { if (lastPointer !== 'touch') activateGroup(item, rail); });
      rail.addEventListener('focus', function () { activateGroup(item, rail); });
      rail.addEventListener('click', function (e) {
        if (lastPointer === 'touch' && !wasActive) {
          e.preventDefault();
          activateGroup(item, rail);
        }
      });
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ip-mega]')) closeAll(null);
  });

  /* ---------- "Scrivici in chat": apre la chat di Zipchat in basso a destra ---------- */
  /* Comando indicato dal supporto Zipchat: window.Zipchat.open({ open: true }) */
  function openChat() {
    var z = window.Zipchat;
    if (!z || typeof z.open !== 'function') return false;
    try { z.open({ open: true }); return true; } catch (err) { return false; }
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-ip-chat]');
    if (!link) return;
    var drawerClose = link.closest('.menu-drawer') ? document.querySelector('.menu-drawer .close-menu-js') : null;
    closeAll(null);
    if (openChat()) {
      e.preventDefault();
      if (drawerClose) drawerClose.click();
    }
    /* se la chat non c'è (o non si è ancora caricata), il link porta alla pagina Contattaci */
  });

  /* ---------- Trustpilot: il widget si carica solo quando il menu è aperto ---------- */
  function loadTrustbox(el, tries) {
    if (el.getAttribute('data-ip-tp-loaded')) return;
    var tp = window.Trustpilot;
    if (tp && typeof tp.loadFromElement === 'function') {
      el.setAttribute('data-ip-tp-loaded', '1');
      el.classList.add('trustpilot-widget');
      tp.loadFromElement(el, true);
    } else if ((tries || 0) < 20) {
      setTimeout(function () { loadTrustbox(el, (tries || 0) + 1); }, 500);
    }
  }
  var trustboxes = document.querySelectorAll('[data-ip-trustpilot]');
  if ('IntersectionObserver' in window) {
    var tpObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        tpObserver.unobserve(entry.target);
        loadTrustbox(entry.target);
      });
    }, { rootMargin: '0px 0px 200px 0px' });
    trustboxes.forEach(function (el) { tpObserver.observe(el); });
  } else {
    trustboxes.forEach(function (el) { loadTrustbox(el); });
  }

  /* ---------- Mobile: schede Cane/Gatto e fisarmonica ---------- */
  /* Ascolto in fase di cattura e fermo l'evento: così i bottoni del menu
     non attivano la logica di chiusura del drawer del tema. */
  document.querySelectorAll('[data-ip-drawer]').forEach(function (drawer) {
    drawer.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-ip-tab]');
      var acc = e.target.closest('[data-ip-acc]');
      if (!tab && !acc) return;
      e.preventDefault();
      e.stopPropagation();

      if (tab) {
        drawer.querySelectorAll('[data-ip-tab]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        return;
      }

      var expanded = acc.getAttribute('aria-expanded') === 'true';
      var body = document.getElementById(acc.getAttribute('aria-controls'));
      acc.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (body) body.hidden = expanded;
    }, true);
  });
})();
